import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=21e3b1f3&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&id=21e3b1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3b1f3",
  null
  
)

export default component.exports